import React from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

export const EducationJobsComponent = () => {
    return (
        <div style={{
            paddingTop: "4%",
            paddingLeft: '4%',
            paddingRight: "4%",
            display: "flex",
            flexDirection: "column",
            alignContent: "center",
            flexWrap: "wrap",
        }}>
            <div>
                <Accordion
                    defaultExpanded={true}
                    style={{backgroundColor: "#FFFFFF", borderRadius: 30 }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <h4><b>$ <span style={{
                            color: "#007BFF"
                        }}> print</span> Experience</b></h4>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div style={{
                            paddingLeft: "3%", paddingRight: "3%", paddingBottom: 20,
                        }}>
                            <h5>
                                <span style={{ color: "#007BFF" }}><b>Researcher,</b></span>
                                <b> Purdue University College of Engineering</b></h5>
                            <h6>Aug 2021 — Present</h6>
                            <li>
                                Conducting AI research to improve the behavior of an existing mathematical reasoner called Ontic.
                            </li>

                            <h5 style={{ paddingTop: 30 }}>
                                <span style={{ color: "#007BFF" }}><b>Software Engineer Intern,</b></span>
                                <b> JPMorgan Chase & Co.</b></h5>
                            <h6>Jun 2021 — Present</h6>
                            <li>
                                Engineered an end-to-end solution for visualizing major news trends over time for the Corporate Investment Bank.
                            </li>
                            <li>
                                Created a Python-based API to analyze thousands of files for trends in vendor data on AWS EMR in real-time.
                            </li>
                            <li>
                                Created a serverless backend using AWS Lambda to fetch millions of data tuples instantly and scale dynamically.
                            </li>
                            <li>
                                Developed key functionality for visualizations of news trends over a time range and the ability to tailor visualization.
                            </li>

                            <h5 style={{ paddingTop: 30 }}>
                                <span style={{ color: "#007BFF" }}><b>Full Stack Developer,</b></span>
                                <b> Indigo</b></h5>
                            <h6>Jun 2020 — Nov 2020</h6>
                            <li>
                                Presented Indigo to Eric Holcomb, Governor of Indiana. Awarded first place winner in tourism category.
                            </li>
                            <li>
                                Indigo is a web app built for collecting and displaying Indianapolis business responses to COVID-19, built using
                                ReactJS, Spring Boot, and MySQL.
                            </li>
                            <li>
                                Spearheaded the development and cross-integration of the front-end, back-end, and database of Indigo.
                            </li>
                            <li>
                                Oversaw user testing for various use cases and user feedback implementation.
                            </li>

                            <h5 style={{ paddingTop: 30 }}>
                                <span style={{ color: "#007BFF" }}><b>Web Developer Intern,</b></span>
                                <b> USR Systems LLC</b></h5>
                            <h6>Jun 2016 — Aug 2018</h6>
                            <li>
                                Developed USR Systems’ website as a web developer intern over the course of three summers using HTML and CSS.
                            </li>
                            <li>
                                Participated in brainstorm meetings on implementing USR’s technology in local health clinics.
                            </li>
                            <li>
                                Advanced skills in Spring (including base Java) via biweekly, personal training sessions.
                            </li>
                        </div>
                    </AccordionDetails>
                </Accordion>
                <hr />
            </div>
            <div>
                <Accordion
                    defaultExpanded={true}
                    style={{backgroundColor: "#FFFFFF", borderRadius: 30, marginBottom: "5%" }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                        style={{ marginLeft: "auto", marginRight: "auto" }}
                    >
                        <h4><b>$ <span style={{
                            color: "#007BFF"
                        }}>print</span> Education</b></h4>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div style={{
                            paddingLeft: "3%", paddingRight: "3%", paddingBottom: 20,
                        }}>
                            <h5><b><span style={{ lineHeight: 0, color: "#007BFF" }}>Purdue University,</span> West Lafayette, IN</b>
                                <br />B.S. Computer Science Honors (Class of 2023)</h5>
                            <br />
                            <h6 style={{ lineHeight: 0, paddingBottom: 5 }}><b>CS Coursework</b></h6>
                            <li style={{"padding": 2}}>
                                CS307: Software Engineering I
                            </li>
                            <li style={{"padding": 2}}>
                                CS251: Data Structures and Algorithms
                            </li>
                            <li style={{"padding": 2}}>
                                CS408: Software Testing
                            </li>
                            <li style={{"padding": 2}}>
                                CS180: Java Programming
                            </li>
                            <li style={{"padding": 2}}>
                                CS240: C Programming
                            </li>
                            <li style={{"padding": 2}}>
                                CS291: Competitive Programming
                            </li>
                            <li style={{"padding": 2}}>
                                CS354: Operating Systems
                            </li>
                            <li style={{"padding": 2}}>
                                CS252: Systems Programming
                            </li>
                            <li style={{"padding": 2}}>
                                CS250: Computer Architecture
                            </li>
                        </div>
                    </AccordionDetails>
                </Accordion>
            </div>
        </div>
    );
}
